import {d} from '@/utils/consoleHelper.ts';
import type {MiddlewareContext} from '@/router';

const KNOWN_TENANT_ROOTS = ['fleetwire.io', 'fleetwire.test'];

export default async function companyStore({store, to}: MiddlewareContext) {
    d.log('%c -- MIDDLEWARE -- COMPANY STORE ✅', 'color: white; background: green; padding: 2px; font-weight: bold;');

    try {
        // 1) explicit query ?company=foo
        const q = to?.query?.company;
        const fromQuery = Array.isArray(q) ? q[0] : (q as string | undefined);

        // 2) window.fwData?.company
        // 3) hostname
        const host = window?.location?.host ?? '';
        const fwDataCompany = (window as any)?.fwData?.company as string | undefined;

        const detectedRaw = fromQuery || fwDataCompany || host;

        const slug = normalizeCompany(detectedRaw);

        d.log('%c 🏢 Detected Company:', 'color: cyan; background: black; font-weight: bold;', slug);

        if (!slug) {
            console.warn('%c ⚠️ No company identifier found!', 'color: orange; font-weight: bold;');
            return;
        }

        // Fetch company details from the Vuex store
        await store.dispatch('company/fetchCompany', slug);
    } catch (error) {
        console.error('%c ❌ Company Store Middleware Error:', 'color: red; font-weight: bold;', error);
    }
}

function normalizeCompany(input: string): string {
    if (!input) return '';
    let s = String(input).toLowerCase();

    // If input is a full URL, strip scheme/path
    s = s.replace(/^https?:\/\//, '').split('/')[0];
    // Strip port
    s = s.split(':')[0];

    // If it’s already a plain slug (no dots), return it
    if (!s.includes('.')) return s;

    // If the host ends with a known tenant root, return the subdomain (first label)
    for (const root of KNOWN_TENANT_ROOTS) {
        const suffix = `.${root}`;
        if (s.endsWith(suffix)) {
            const withoutRoot = s.slice(0, -suffix.length);
            return withoutRoot.split('.')[0]; // first label as company slug
        }
    }

    // Custom domains: fall back to the entire host
    return s;
}
